window.addEventListener('load', () => {
    initializeAudioBlock();
});

window.addEventListener('resize', () => {

});

function initializeAudioBlock() {
    const players = document.querySelectorAll('.audio-player-container');

    players.forEach(player => {
        const audio = player.querySelector('.audio-element');
        const btn = player.querySelector('.play-pause-btn');
        const playIcon = btn.querySelector('.icon-play');
        const pauseIcon = btn.querySelector('.icon-pause');

        btn.addEventListener('click', () => {
            if (audio.paused) {
                audio.play();
                playIcon.style.display = 'none';
                pauseIcon.style.display = 'block';
            } else {
                audio.pause();
                playIcon.style.display = 'block';
                pauseIcon.style.display = 'none';
            }
        });

        audio.addEventListener('ended', () => {
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
        });
    });
}

